import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import prism from 'react-syntax-highlighter/dist/esm/styles/prism/prism';
// import {dracula} from 'react-syntax-highlighter/dist/esm/styles/hljs';
const SyntaxHighlighterComp = ({codeString}) => {
//     const codeString = `
// namespace network
// {
// 	class Server
// 	{
// 	public:

// 		Server(bool isThreadMode = true);
// 		virtual ~Server();

// 		virtual bool Initialize( std::string anIp );
// 		virtual void Process();

// 		bool InitWSA();
// 		bool HasInitWSA() const; 

// 		virtual bool IsConnected();
// 		virtual bool IsReadyConnect();
// 		virtual bool IsFailConnection();

// 		virtual const uint32_t GetGamObjectID();
// 		void ReleaseGameObjectID(uint32_t aGID);
// 		virtual const uint32_t GetComponentID();
// 		void ReleaseComponentID(uint32_t aCID);

// 	protected:

// 		virtual void OnConnect( TCPConnection& aNewConnection );
// 		virtual void OnDisconnect( TCPConnection& aLostConnection, std::string aReason );

// 		void CloseConnection( int aConnectionIndex, std::string aReason );
// 		virtual bool ProcessPacket( std::shared_ptr<Packet> aPacket );

// 		static unsigned WINAPI ThreadFunction(Server* aServer);

// 	protected:

// 		Socket myListeningSocket;
// 		std::vector<TCPConnection> myConnections;
// 		std::vector<WSAPOLLFD> myMaster_fd;
// 		std::vector<WSAPOLLFD> myUse_fd;

// 		std::thread myThread;
// 		bool myIsThreadMode;

// 		bool myHasInitWSA;
// 		eState myState;

// 		uint32_t myCurrentGameObjectID;
// 		uint32_t myCurrentComponentID;
// 		std::priority_queue<uint32_t> myUnclamiedGameObjectID;
// 		std::priority_queue<uint32_t> myUnclamiedComponentID;

// 		static uint32_t myServerID;
// 		static uint32_t myClientID;
// 	};
// }`;


    return (
      <SyntaxHighlighter language="cpp" style={atomOneDark}>
        {codeString}
      </SyntaxHighlighter>
    );
}

export default SyntaxHighlighterComp